<template>
    <div>
        <v-progress-linear v-for="r in result" :key="r.idx" :value="r.val" height="20" style="color: white;"><span
                style="padding:8px">{{ r.label }} : {{ r.c }}({{ r.val }}%)</span></v-progress-linear>
    </div>
</template>
<script>
export default {
    name: "rating-feedback",
    props: {
        cfg: Object,
    },
    data() {
        return {
            result: []
        };
    },
    watch: {
        cfg() {
            this.init();
        }
    },
    methods: {
        init() {
            let self = this, cfg = self.cfg, result = [], total = 0;
            for (let k in cfg.result) {
                let c = cfg.result[k];
                result.push({ label: k, c: c });
                total += c;
            }
            for (let r of result) {
                r.val = ((r.c * 100) / total).toFixed(1);
            }
            self.result = result;
        }
    },
    created() {
        this.init();
    }
};
</script>